
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { SMCases } from "@/store";
import { API_TCaseSummary } from "@/models/case_summary";
import Image from "@/assets/images/people/person-1.png";

@Component
export default class Summary extends Vue {
  summary: API_TCaseSummary = {} as API_TCaseSummary;

  get id(): number {
    return Number(this.$route.params.id ?? 0);
  }

  async fetchSummary() {
    const caseDashboardId = SMCases.tabId;

    const { data } = await this.axios.get(API_ROUTES.CASE_SUMMARY(this.id, caseDashboardId));

    if (!data) return;

    this.summary = data;
  }

  async mounted() {
    await this.fetchSummary();
  }

  async activated() {
    await this.fetchSummary();
  }

  get styles() {
    return `backgroundImage: url(${Image})`;
  }
}
